<feature-page-layout-notification-banner></feature-page-layout-notification-banner>

<div>
  <div [ngClass]="[isSideBarHidden()]" class="gray-bg d-flex flex-column min-vh-100">
    <feature-notification-handling-notification></feature-notification-handling-notification>
    <div>
      <div [ngClass]="[isNavMenuHidden()]" class="mb-2">
        <shared-ui-navbars-horizontal-navbar [items]="menuItems" [startTemplate]="startTemplate" [endTemplate]="endTemplate">
          <ng-template #startTemplate>
            <img class="logo-img" [src]="appConfig.statics.blueLogo" />
          </ng-template>

          <ng-template #endTemplate>
            <shared-ui-navbars-navbar-header
              *ngIf="user$ | async as user"
              [imageUrl]="user.imageUrl"
              [subheadingDropdown]="menuService.getHeaderMenuItems() | async"
              [heading]="user.fullName"
              [subheading]="user.role | userRoleToString"
              [userDetailsInDropdown]="true"
              [userUid]="user.uid"
              [canOpenUserProfile]="(canAccessOwnProfile() | async) ?? false"
              [dropdownPlacement]="'bottom-end'"
            ></shared-ui-navbars-navbar-header>
          </ng-template>
        </shared-ui-navbars-horizontal-navbar>
      </div>
    </div>

    <main class="flex-fill">
      <ng-content></ng-content>
    </main>

    <shared-ui-page-toolbars-footer class="mb-2" [text]="'layout-one-footer' | translate"></shared-ui-page-toolbars-footer>
  </div>
</div>
